/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconNavigationContacts = ({ size = 16, className = '', ...props }) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
  >
    <path
      fill="currentColor"
      d="M8.8 5.857l.988 1.138a1.104 1.104 0 0 0 1.765.001l.987-1.139c.085-.164.13-.346.13-.531V3.807c0-.941-1.075-1.703-1.999-1.703s-2.002.763-2.002 1.703l.002 1.521c0 .185.045.367.13.53zM4.647 3.771c-.77 0-1.668.667-1.668 1.491l.002 1.331c0 .162.037.321.108.464l.823.996a.893.893 0 0 0 1.47.001l.822-.997c.071-.143.108-.303.108-.465V5.263c0-.823-.896-1.491-1.666-1.491zM14.013 8.858l-.88-.91a.332.332 0 0 0-.421-.048l-1.533.994a.962.962 0 0 1-1.02-.001l-1.533-.994a.335.335 0 0 0-.428.055l-.922 1.011a2.332 2.332 0 0 0-.608 1.571v3.027c0 .184.149.333.333.333h7.295a.254.254 0 0 1 .039 0 .333.333 0 0 0 .333-.333v-3.084c0-.609-.233-1.185-.656-1.623zM5.613 9.265l-.594.315a.682.682 0 0 1-.746 0l-1.247-.84a.33.33 0 0 0-.432.056l-.678.771a2.34 2.34 0 0 0-.582 1.544v2.454c0 .184.149.333.333.333h4.001a.333.333 0 0 0 .333-.333v-4.15c0-.183-.223-.232-.388-.149z"
    />
  </svg>
);

IconNavigationContacts.displayName = 'IconNavigationContacts';

IconNavigationContacts.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconNavigationContacts);
IconNavigationContacts.displayName = 'IconNavigationContacts';
